import React from 'react';
import { func } from 'prop-types';
import { Button } from '@mui/material';
import { I18n } from 'utils/i18n';

const CancelButton = ({ onClick }) => (
  <Button onClick={onClick} variant="contained" color="secondary">
    {I18n.t('Dialog.Cancel')}
  </Button>
);
CancelButton.propTypes = {
  onClick: func.isRequired,
};

export default CancelButton;
